import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-sujet-form',
  templateUrl: './note-sujet-form.component.html',
  styleUrls: ['./note-sujet-form.component.scss']
})
export class NoteSujetFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
